<template>
    <section v-if="visibleInventoryLinkCount >= 2" class="property-filterlink" :class="{'show-more': showMore2}" comp="propertyFilterlink">
        <div class="f2 text-bold">Narrow your search</div>
        <div class="property-linklist">
            <a v-if="inventoryInfo?.homeOpenCount > 0" :href="`${glb.appUrl}${dpp.geo.cityPath}open-houses/`">{{ dpp.geo.city }} open houses</a>
            <a v-if="inventoryInfo?.singleFamilyCount > 0" :href="`${glb.appUrl}${dpp.geo.cityPath}single-family/`">{{ dpp.geo.city }} single family homes for sale</a>
            <a v-if="inventoryInfo?.condoCount > 0" :href="`${glb.appUrl}${dpp.geo.cityPath}condos/`">{{ dpp.geo.city }} condos and townhomes for sale</a>
            <a v-if="inventoryInfo?.homeForSaleCount > 0" :href="`${glb.appUrl}${dpp.geo.cityPath}multi-family/`">{{ dpp.geo.city }} multi-family and duplexes for sale</a>
            <a v-if="inventoryInfo?.homeForSaleCount > 0" :href="`${glb.appUrl}${dpp.geo.cityPath}land/`">{{ dpp.geo.city }} lots and land for sale</a>
            <a v-if="inventoryInfo?.homeForSaleCount > 0" :href="`${glb.appUrl}${dpp.geo.cityPath}mobile/`">{{ dpp.geo.city }} mobile and manufactured homes for sale</a>
            <a v-if="inventoryInfo?.homeForSaleCount > 0" :href="`${glb.appUrl}${dpp.geo.cityPath}sold/`">{{ dpp.geo.city }} recently sold homes</a>
            <a v-if="inventoryInfo?.homeForSaleCount > 0" :href="`${glb.appUrl}${dpp.geo.cityPath}foreclosed/`">{{ dpp.geo.city }} foreclosed homes for sale</a>
            <a v-if="inventoryInfo?.homeForSaleCount > 0" :href="`${glb.appUrl}${dpp.geo.cityPath}rentals/`">{{ dpp.geo.city }} rentals</a>
            <a v-if="inventoryInfo?.homeForSaleCount > 0" :href="`${glb.appUrl}${dpp.geo.cityPath}rentals/single-family/`">{{ dpp.geo.city }} single family for rent</a>
            <a v-if="inventoryInfo?.homeForSaleCount > 0" :href="`${glb.appUrl}${dpp.geo.cityPath}rentals/condos/`">{{ dpp.geo.city }} apartments for rent</a>
        </div>
        <button type="button" @click="toggleShowMore2">{{ showMore2 ? 'Show Less' : 'Show More' }} <i :class="showMore2 ? 'icon-angle-up' : 'icon-angle-down'"></i></button>
    </section>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'propertyGeoFilterLink',
    props: {
        inventoryInfo: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            showMore2: false,
        };
    },
    methods: {
        toggleShowMore2() {
            this.showMore2 = !this.showMore2;
        },
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dpp', ['dpp']),
        visibleInventoryLinkCount() {
            const inv = this.inventoryInfo || {};
            let n = 0;
            if (inv.homeOpenCount > 0) n += 1;
            if (inv.singleFamilyCount > 0) n += 1;
            if (inv.condoCount > 0) n += 1;
            const saleBucket = inv.homeForSaleCount > 0 ? 1 : 0;
            n += saleBucket * 8;
            return n;
        },
    },
};
</script>
